module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block mijnschades"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_c('a', {
    attrs: {
      "href": _vm.ctx + '/mijnschades.html'
    }
  }, [_vm._v("Mijn schades")])])]), _vm._v(" "), (_vm.mijnschades.length != 0) ? _c('div', {
    staticClass: "card-block full-width"
  }, [_c('ul', {
    staticClass: "link list insurances"
  }, _vm._l((_vm.mijnschades), function(schade) {
    return (schade.schadestatus != 'afgehandeld') ? _c('li', [_c('a', {
      attrs: {
        "href": _vm.ctx + '/mijnschades.html'
      }
    }, [_c('p', {
      staticClass: "icon icon-sm"
    }, [_c('span', {
      class: 'icon-' + schade.produktTypeNaam
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(schade.produktNaam))]), _vm._v(" "), (schade.kenteken) ? _c('span', [_vm._v(_vm._s(schade.kenteken))]) : _vm._e(), _vm._v(" "), (schade.produktTypeNaam == 'woonhuis' || schade.produktTypeNaam == 'inboedel') ? _c('span', [_vm._v(_vm._s(schade.straat))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "tag",
      class: [{
        'tag-danger': schade.schadestatus == 'wacht op uw reactie'
      }, {
        'tag-success': schade.schadestatus == 'in behandeling'
      }, {
        'tag-success': schade.schadestatus == 'beoordeling'
      }, {
        'tag-success': schade.schadestatus == 'ontvangen'
      }]
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(schade.schadestatus) + "\n\t\t\t\t\t\t")])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "error"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22937f91"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/schade/schadestatus.vue
// module id = 109
// module chunks = 0